/* @flow weak */
import { Signature } from 'constants/CopyConstants';
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import DialogContent from 'components/DialogContent.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import FormSelect from 'components/FormSelect.jsx';
import Prefixes from 'lib/Prefixes.js';
import PromptActions from 'actions/PromptActions';
import PromptStore from 'stores/PromptStore';
import React from 'react';
import RequireUser from 'components/mixins/RequireUser';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';
import { PromptNames } from 'constants/PromptConstants';

import './styles/SetupSignature.scss';

const SetupSignature = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    RequireUser,
  ],

  getInitialState() {
    return {
      enable: false,
      prefix: CurrentUser.getUser().getPrefix() || '',
    };
  },

  componentDidMount() {
    if (!PromptStore.hasDismissed(PromptNames.NUX_SETUP_SIGNATURE)) {
      PromptActions.recordDismissal(PromptNames.NUX_SETUP_SIGNATURE);
    }
  },

  onPrefixChange(prefix) {
    this.setState({ prefix });
  },

  submit(attrs) {
    const onSuccess = () => {
      ToastActions.showSuccessToast('Saved!');
      this.context.router.push('/');
    };

    const onFailure = (error) => ToastActions.showAPIError(error);

    if (attrs.prefix) {
      attrs.signature = attrs.prefix + ' ' + attrs.signature;
    }

    UserActions
      .update(attrs)
      .then(onSuccess, onFailure);
  },

  render() {
    // if there's a prefix we concat the signature and the prefix
    // so the max length of the signature is not 18 but (18 - 'Mr. '.length)
    const maxLength = this.state.prefix.length > 0 ?
      18 - ((this.state.prefix.length + 1) /* space */) :
      18;

    return (
      <DialogContent
        size="small"
        full
        className="SetupSignature"
        title="What do students and parents call you?"
        subtext={Signature.explanation}>
        <BoxBody divided>
          <div className="SetupSignature">
            <Form
              onValidSubmit={this.submit}
              onValid={() => this.setState({ enabled: true })}
              onInvalid={() => this.setState({ enabled: false })}>
              <div className="SetupSignature-Title">
                <FormSelect
                  label="Title"
                  name="prefix"
                  value={CurrentUser.getUser().getPrefix()}
                  onChange={this.onPrefixChange}
                  options={Prefixes}
                  placeholder="[No title]"
                  searchable={false}
                />
              </div>
              <div className="SetupSignature-Name">
                <FormInput
                  label="Name"
                  required
                  name="signature"
                  showErrorOnPristine
                  value={CurrentUser.getUser().getSignature()}
                  validations={{ maxLength }}
                  validationErrors={{
                    maxLength: `Signature should be shorter than ${maxLength + 1} characters.`,
                  }}
                />
              </div>
              <Button
                disabled={!this.state.enabled}
                className="SetupSignature-Submit"
                type="submit"
                eventElementName="SetupSignature-Submit">
                Next
              </Button>
            </Form>
          </div>
        </BoxBody>
      </DialogContent>
    );
  },
});

export default SetupSignature;



// WEBPACK FOOTER //
// ./src/setup/components/SetupSignature.jsx